{
  "constructor-share": "Поделиться",
  "facebook-title": "Откроется в новой вкладке",
  "twitter-title": "Откроется в новой вкладке",
  "linkedin-title": "Откроется в новой вкладке",
  "vk-title": "Откроется в новой вкладке",
  "telegram-title": "Откроется в новой вкладке",
  "facebook-label": "Facebook лого",
  "twitter-label": "Twitter лого",
  "linkedin-label": "LinkedIn лого",
  "vk-label": "VK лого",
  "telegram-label": "Telegram лого"
}
